import { render, staticRenderFns } from "./videoCenter.vue?vue&type=template&id=6bec5390&scoped=true"
import script from "./videoCenter.vue?vue&type=script&lang=js"
export * from "./videoCenter.vue?vue&type=script&lang=js"
import style0 from "./videoCenter.vue?vue&type=style&index=0&id=6bec5390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bec5390",
  null
  
)

export default component.exports